import PageHeader from './PageHeader.styled';

export default PageHeader;
